import { Typography } from "@mui/material";
import { useSelector } from "react-redux";

const VitalsView = ({ vitals }) => {
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);

  return (
    <div className="ph10">
      {(vitals ?? reqDet?.vitals)?.map((vit) => (
        <div className="gray-back-con" key={vit?.vitalId}>
          <div className="flex-row-ali-cen">
            <div className="gray-dot" />
            <Typography className="black fs12 font-bold ml5">
              {vit?.vitalGroup}
            </Typography>
            <div className="gray-dot ml5" />
            <Typography className="black fs12 font-bold ml5">
              Temperature : {vit?.temperature} °F
            </Typography>
            <div className="gray-dot ml5" />
            <Typography className="black fs12 font-bold ml5">
              Heart Rate (Pulse) : {vit?.heartRate} bpm
            </Typography>
          </div>
          <div className="flex-row-ali-cen mt5">
            <div className="gray-dot" />
            <Typography className="black fs12 font-bold ml5">
              Respiratory Rate : {vit?.respiratoryRate} brpm
            </Typography>
            <div className="gray-dot ml5" />
            <Typography className="black fs12 font-bold ml5">
              Mucous Membrane Color : {vit?.mmColor}
            </Typography>
            <div className="gray-dot ml5" />
            <Typography className="black fs12 font-bold ml5">
              Capillary Refill Time (CRT): {vit?.crt} seconds
            </Typography>
          </div>
          <div className="flex-row-ali-cen mt5">
            <div className="gray-dot" />
            <Typography className="black fs12 font-bold ml5">
              Weight: {vit?.weigth} KG
            </Typography>
            <div className="gray-dot ml5" />
            <Typography className="black fs12 font-bold ml5">
              Body Condition Score (BCS): {vit?.bcs}
            </Typography>
            <div className="gray-dot ml5" />
            <Typography className="black fs12 font-bold ml5">
              Remarks: {vit?.remarks}
            </Typography>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VitalsView;
